import Home from "./Home"
import General from "./General"

export { General }
export default Home
